var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9c84b2;\n        opacity: .25;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        opacity: .23;\n      }\n\n      .cls-2, .cls-44, .cls-45, .cls-46, .cls-3, .cls-4, .cls-29, .cls-47, .cls-31, .cls-32, .cls-33, .cls-42 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-6, .cls-29, .cls-32, .cls-33, .cls-42, .cls-43 {\n        fill: #fff;\n      }\n\n      .cls-44 {\n        opacity: .6;\n      }\n\n      .cls-45, .cls-33 {\n        opacity: .35;\n      }\n\n      .cls-46, .cls-4 {\n        opacity: .49;\n      }\n\n      .cls-48 {\n        mask: url(#mask);\n      }\n\n      .cls-3 {\n        opacity: .97;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-49 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .cls-6 {\n        opacity: .7;\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient);\n        mix-blend-mode: multiply;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-28 {\n        fill: #adb2bb;\n      }\n\n      .cls-29 {\n        opacity: .61;\n      }\n\n      .cls-30 {\n        fill: #9097a5;\n      }\n\n      .cls-31 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-32 {\n        opacity: .2;\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-50 {\n        isolation: isolate;\n      }\n\n      .cls-42 {\n        opacity: .41;\n      }\n\n      .cls-51 {\n        mask: url(#mask-1);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 499.79,
    y1: 636.53,
    x2: 499.79,
    y2: 357.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2b2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6ffd4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 499.79,
    y1: 754.24,
    x2: 499.79,
    y2: 616.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 499.79,
    y1: 414.42,
    x2: 499.79,
    y2: 279.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 499.43,
    y1: 422.14,
    x2: 499.43,
    y2: 79.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 312.76,
    y1: 285.79,
    x2: 331.99,
    y2: 754.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6ffd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2b2e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -9755.29,
    y1: 285.96,
    x2: -9736.06,
    y2: 754.2,
    gradientTransform: "translate(-9078.38) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 493.43,
    y1: 97.75,
    x2: 493.43,
    y2: 361.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#defffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d6ffd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adb2bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 565.43,
    y1: 284.76,
    x2: 619.5,
    y2: 379.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6ffd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4c3bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 494.5,
    y1: 301.54,
    x2: 659.12,
    y2: 301.54,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -5390.83,
    y1: 284.76,
    x2: -5336.76,
    y2: 379.52,
    gradientTransform: "translate(-4966.03) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 414.08,
    y1: 269.75,
    x2: 412.41,
    y2: 358.38,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 485.57,
    y1: 278.7,
    x2: 504.8,
    y2: 746.93,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 525.09,
    y1: 671.51,
    x2: 479.1,
    y2: 443.25,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 348.64,
    y1: 667.81,
    x2: 305.44,
    y2: 596.19,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -6728.34,
    y1: 667.81,
    x2: -6771.54,
    y2: 596.19,
    gradientTransform: "translate(-6089) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 390.28,
    y: 295.42,
    width: 91.98,
    height: 85.66,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 390.28,
    y: -8573,
    width: 91.98,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 390.28,
    y: -8573,
    width: 91.98,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 436.27,
    cy: 338.25,
    fx: 436.27,
    fy: 338.25,
    r: 44.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 390.28,
    y: 295.42,
    width: 91.98,
    height: 85.66,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M436.27,295.42c-25.4,0-45.99,19.18-45.99,42.85s20.6,42.81,45.99,42.81,45.99-19.19,45.99-42.81-20.6-42.85-45.99-42.85Z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 436.27,
    cy: 338.25,
    fx: 436.27,
    fy: 338.25,
    r: 44.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1160.99,
    y1: -1739.94,
    x2: 1219.31,
    y2: -1637.72,
    gradientTransform: "translate(-1171.53 1288.51) rotate(34.06)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1093.88,
    y1: -1719.19,
    x2: 1251.77,
    y2: -1719.19,
    gradientTransform: "translate(-1171.53 1288.51) rotate(34.06)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -4423.79,
    y1: 2034.92,
    x2: -4365.47,
    y2: 2137.15,
    gradientTransform: "translate(-4574.09 1288.51) rotate(145.94) scale(1 -1)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -4490.9,
    y1: 2055.67,
    x2: -4333.01,
    y2: 2055.67,
    gradientTransform: "translate(-4574.09 1288.51) rotate(145.94) scale(1 -1)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 539.46,
    y1: 692.33,
    x2: 574.55,
    y2: 753.83,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 493.42,
    y1: 703.22,
    x2: 600.27,
    y2: 703.22,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -5413.52,
    y1: 692.33,
    x2: -5378.43,
    y2: 753.83,
    gradientTransform: "translate(-4966.03) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 440.54,
    y1: 682.59,
    x2: 439.45,
    y2: 740.11,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -6058.11,
    y1: -2885.25,
    x2: -6023.01,
    y2: -2823.75,
    gradientTransform: "translate(-5610.61 -2099.1) rotate(-180)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 472.34,
    y1: 818.91,
    x2: 434.99,
    y2: 765.95,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1184.04,
    y1: -2885.25,
    x2: 1219.14,
    y2: -2823.75,
    gradientTransform: "translate(-644.58 -2099.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 519.69,
    y1: 838.28,
    x2: 546.44,
    y2: 774.18,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 492.63,
    y1: 693.73,
    x2: 496.67,
    y2: 899.33,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 498.97,
    y1: 761.1,
    x2: 490.37,
    y2: 718.44,
    xlinkHref: "#linear-gradient-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_13",
    "data-name": "Layer 13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M822.43,433.81H177.15c-7.03,0-74.65,74.71-74.65,101.52s67.61,101.52,74.65,101.52h645.28c7.03,0,74.65-74.71,74.65-101.52s-67.61-101.52-74.65-101.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M589.61,653.95H190.61c0,27.78,67.61,100.45,74.65,100.45h469.06c7.03,0,74.65-72.67,74.65-100.45h-219.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M648.27,414.58h160.7c0-25.65-67.61-98.32-74.65-98.32h-469.06c-7.03,0-74.65,72.67-74.65,98.32h457.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M119.27,535.33c0,26.81,67.61,101.52,74.65,101.52h-16.76c-7.03,0-74.65-74.71-74.65-101.52s67.61-101.52,74.65-101.52h16.76c-7.03,0-74.65,74.71-74.65,101.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M282.02,754.41h-16.76c-7.03,0-74.65-72.67-74.65-100.45h16.76c0,27.78,67.61,100.45,74.65,100.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M207.37,414.58h-16.76c0-25.65,67.61-98.32,74.65-98.32h16.76c-7.03,0-74.65,72.67-74.65,98.32Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M880.31,535.33c0,26.81-67.62,101.52-74.65,101.52h16.76c7.03,0,74.65-74.71,74.65-101.52s-67.61-101.52-74.65-101.52h-16.76c7.03,0,74.65,74.71,74.65,101.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M717.56,754.41h16.76c7.03,0,74.65-72.67,74.65-100.45h-16.76c0,27.78-67.62,100.45-74.65,100.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M792.21,414.58h16.76c0-25.65-67.61-98.32-74.65-98.32h-16.76c7.03,0,74.65,72.67,74.65,98.32Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M707.97,160.47c-9.23,0-16.71,7.48-16.71,16.7,0,4.54,1.82,8.64,4.77,11.64-14.37,5.16-39.79,13.2-65.93,16.39-2.24-3.44-3.59-7.96-3.3-13.95.63-13.2.59-26.39.41-35.99.81.09,1.63.16,2.46.16,11.72,0,21.23-9.5,21.23-21.22s-9.5-21.22-21.23-21.22-21.22,9.5-21.22,21.22c0,5.73,2.29,10.92,5.98,14.74l-49.94,33.43-55.35-82.91c9.21-3.85,15.69-12.94,15.69-23.54,0-14.1-11.43-25.51-25.52-25.51s-25.5,11.41-25.5,25.51c0,10.61,6.46,19.69,15.67,23.54l-55.26,82.77-49.74-33.29c3.69-3.82,5.97-9.01,5.97-14.74,0-11.72-9.5-21.22-21.22-21.22s-21.23,9.5-21.23,21.22,9.51,21.22,21.23,21.22c.83,0,1.64-.06,2.45-.16-.18,9.6-.21,22.79.41,35.99.28,6.01-1.07,10.55-3.31,13.99-26.12-3.15-51.54-11.18-65.97-16.34,2.97-3.01,4.81-7.15,4.81-11.72,0-9.23-7.48-16.7-16.71-16.7s-16.7,7.48-16.7,16.7,7.47,16.71,16.7,16.71c.6,0,1.17-.11,1.75-.18l21.7,121.35v10.29s18.55-1.18,178.64-1.18h12.63c160.09,0,178.64,1.18,178.64,1.18v-10.29l21.71-121.38c.67.09,1.33.21,2.02.21,9.23,0,16.71-7.48,16.71-16.71s-7.48-16.7-16.71-16.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M509.91,99.46c-.28.13-.49.5-.78.62l62.89,94.07,46.25-41.54c-3.7-3.82-2.29-.9-2.29-6.63,0-11.72,9.5-21.22,21.22-21.22,5.41,0,10.33,2.04,14.08,5.37-1.9-9.77-10.5-17.15-20.83-17.15-11.72,0-21.22,9.5-21.22,21.22,0,5.73,2.29,10.92,5.99,14.74l-49.94,33.43-55.36-82.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M481.33,87.71c0-14.1,11.41-25.52,25.5-25.52,7,0,13.33,2.82,17.94,7.38-2.83-11.01-12.8-19.16-24.69-19.16-14.09,0-25.5,11.41-25.5,25.51,0,7.08,2.89,13.48,7.55,18.1-.52-2.02-.8-4.13-.8-6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M634.32,204.75c.03,5.15,1.31,9.15,3.33,12.24,26.13-3.19,51.56-11.23,65.93-16.38-2.95-3.01-4.77-7.11-4.77-11.65,0-9.23,7.49-16.7,16.71-16.7,3.7,0,7.11,1.22,9.88,3.25-.84-8.44-7.96-15.04-16.63-15.04-9.23,0-16.71,7.48-16.71,16.7,0,4.54,1.82,8.64,4.77,11.64-13.74,4.93-37.6,12.49-62.51,15.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M379.61,203.04c-.62-13.19-.59-26.39-.4-35.98-.81.09-5.44-11.48-6.86-11.79-.01,7.54.12,27.49.52,35.99.28,6.01-1.07,10.55-3.31,13.99-20.33-2.45-40.21-7.86-54.84-12.57-.71,3.08-2.24,5.84-4.38,8.01,14.43,5.16,39.85,13.19,65.97,16.35,2.25-3.44,3.6-7.98,3.31-13.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M392,160.72l49.74,33.3,49.91-76.17c3.44-7.95,1.21-15.25-1.4-18.39l-55.25,82.77-49.74-33.29c-.94,1.8-.07,4.41,6.75,11.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M322.47,325.14l-21.84-119.64c-.58.06-1.38.18-1.98.18-.99,0-1.18-.1-2.12-.27l20.39,109.65v10.29s.46-.08,5.55-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M281.73,188.96c0-9.23,7.47-16.7,16.7-16.7,3.7,0,7.11,1.21,9.87,3.25-.84-8.44-7.96-15.04-16.62-15.04-9.23,0-16.7,7.48-16.7,16.7,0,5.53,2.7,10.42,6.84,13.46-.06-.55-.09-1.11-.09-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M355.93,150.05c-.25-1.32-.4-2.68-.4-4.07,0-11.72,9.51-21.22,21.23-21.22,5.41,0,10.33,2.04,14.08,5.37-1.9-9.77-10.5-17.15-20.83-17.15-11.71,0-21.22,9.5-21.22,21.22,0,6.31,2.77,11.96,7.15,15.85Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M438.21,741.09s-42.51,20.58-116.58-8.68c-74.06-29.26-97.61-67.89-97.61-67.89l39.43-22.97s-41.09-32.2-57.54-91.63c-16.45-59.43-14.57-66.95-14.57-66.95h36.57s-10.97-12.66,9.14-77.57c20.12-64.92,39.31-77.65,39.31-77.65l27.43,28.38s11.88-29.24,42.06-54.84c30.17-25.6,61.26-36.56,61.26-36.56l36.55,52.22-5.46,424.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M212.61,560.27c-16.46-59.43-14.57-66.62-14.57-66.62h36.57s-10.97-12.99,9.14-77.9c20.12-64.92,39.32-77.81,39.32-77.81l27.43,28.3s11.88-29.28,42.06-54.88c26.12-22.16,52.9-33.36,59.64-35.97l-5.06-10.65s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.85-42.06,54.85l-27.43-28.35s-19.2,12.67-39.31,77.59c-20.11,64.92-9.14,77.57-9.14,77.57h-36.57s-1.88,7.51,14.57,66.95c6.84,24.68,17.92,44.8,28.54,59.71-8.39-13.45-16.45-29.83-21.86-49.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M275.48,640.39s-1.03-1.61-14.62,2.67l-36.83,21.45s2.24,3.66,7.48,9.57l43.97-33.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M443.68,316.95l-36.55-52.22s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.86-42.06,54.86l-27.43-28.35s-19.2,12.67-39.31,77.59c-20.11,64.91-9.14,77.57-9.14,77.57h-36.57s-1.88,7.51,14.57,66.95c16.46,59.43,57.54,91.57,57.54,91.57l-39.43,23s7.79,12.75,28.41,29.13c18.58,4.23,37.91,6.47,57.76,6.47,46.11,0,89.4-12.04,126.92-33.13l6.56-350.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M435.73,572.62l7.95-255.68-36.55-52.22s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.86-42.06,54.86l-27.43-28.35s-19.2,12.67-39.31,77.59c-20.11,64.91-9.14,77.57-9.14,77.57h-36.57s-1.88,7.51,14.57,66.95c.78,2.83,1.64,5.63,2.52,8.33,34.04,27,77.1,43.17,123.93,43.17,37.84,0,73.21-10.5,103.36-28.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M434.35,478.67l9.33-161.73-36.55-52.22s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.86-42.06,54.86l-27.43-28.35s-18.66,12.46-38.46,75c24.62,51.63,77.28,87.3,138.28,87.3,20.59,0,40.21-4.07,58.15-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M324.21,323.54c14.81,30.5,46.09,51.52,82.27,51.52,9.14,0,17.96-1.36,26.29-3.85l10.91-54.26-36.55-52.22s-31.09,10.97-61.26,36.57c-8.69,7.37-15.85,15.04-21.66,22.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M227.92,476.56s-2.32-2.72-2.87-11.99c-.25,5.11-.05,7.72.33,11.99h2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M321.64,724.04c-56.57-22.35-83.65-50.15-93.29-62.04l-4.32,2.52s23.55,38.63,97.61,67.89c74.06,29.26,116.58,8.68,116.58,8.68l-.12-8.3c-2.53,1.16-44.67,19.61-116.45-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M263.22,641.54l12.26-1.99s-53.23-38.57-69.69-98c-9.13-32.96-12.48-50.04-13.77-58.59h-.67s-2.01,7.51,14.45,66.95c12.68,45.79,42.1,79.33,57.43,91.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M547.46,741.09s42.51,20.58,116.57-8.68c74.06-29.26,97.61-67.89,97.61-67.89l-39.43-22.97s41.09-32.2,57.55-91.63c16.46-59.43,14.57-66.95,14.57-66.95h-36.57s10.97-12.66-9.14-77.57c-20.12-64.92-39.32-77.65-39.32-77.65l-27.43,28.38s-11.89-29.24-42.06-54.84c-30.17-25.6-61.26-36.56-61.26-36.56l-28.18,43.86-2.9,432.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M773.06,560.27c16.45-59.43,14.57-66.62,14.57-66.62h-36.57s10.97-12.99-9.15-77.9c-20.12-64.92-39.32-77.81-39.32-77.81l-27.43,28.3s-11.88-29.28-42.06-54.88c-26.11-22.16-52.9-33.36-59.63-35.97l5.06-10.65s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.85,42.06,54.85l27.43-28.35s19.2,12.67,39.32,77.59c20.11,64.92,9.14,77.57,9.14,77.57h36.57s1.89,7.51-14.57,66.95c-6.84,24.68-17.92,44.8-28.54,59.71,8.38-13.45,16.45-29.83,21.85-49.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M710.19,640.39s1.03-1.61,14.62,2.67l36.83,21.45s-2.24,3.66-7.48,9.57l-43.97-33.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M550.36,308.58l28.18-43.86s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.86,42.06,54.86l27.43-28.35s19.2,12.67,39.32,77.59c20.11,64.91,9.14,77.57,9.14,77.57h36.57s1.89,7.51-14.57,66.95c-16.46,59.43-57.55,91.57-57.55,91.57l39.43,23s-7.79,12.75-28.41,29.13c-18.57,4.23-37.91,6.47-57.76,6.47-46.1,0-89.4-12.04-126.92-33.13l1.81-358.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M549.94,572.62l.42-264.04,28.18-43.86s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.86,42.06,54.86l27.43-28.35s19.2,12.67,39.32,77.59c20.11,64.91,9.14,77.57,9.14,77.57h36.57s1.89,7.51-14.57,66.95c-.78,2.83-1.64,5.63-2.53,8.33-34.04,27-77.1,43.17-123.93,43.17-37.84,0-73.21-10.5-103.35-28.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M551.32,478.67l-.96-170.09,28.18-43.86s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.86,42.06,54.86l27.43-28.35s18.66,12.46,38.46,75c-24.61,51.63-77.28,87.3-138.29,87.3-20.58,0-40.21-4.07-58.14-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M661.47,323.54c-14.82,30.5-46.08,51.52-82.27,51.52-9.14,0-17.96-1.36-26.29-3.85l-2.55-62.62,28.18-43.86s31.09,10.97,61.26,36.57c8.68,7.37,15.85,15.04,21.66,22.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M757.75,476.56s2.32-2.72,2.87-11.99c.25,5.11.05,7.72-.34,11.99h-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M664.03,724.04c56.58-22.35,83.65-50.15,93.29-62.04l4.31,2.52s-23.54,38.63-97.61,67.89c-74.06,29.26-116.57,8.68-116.57,8.68l.12-8.3c2.52,1.16,44.67,19.61,116.45-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M722.45,641.54l-12.26-1.99s53.22-38.57,69.68-98c9.13-32.96,12.49-50.04,13.78-58.59h.67s2.01,7.51-14.45,66.95c-12.68,45.79-42.09,79.33-57.42,91.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "493.43 140.11 405.16 264.93 493.43 389.74 581.7 264.93 493.43 140.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "493.43 151.97 577.51 270.86 581.7 264.93 493.43 140.11 405.16 264.93 409.36 270.86 493.43 151.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "492.77 388.95 580.49 264.93 492.77 140.9 492.77 388.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "495.73 291.87 494.07 141.01 493.43 140.11 407.88 261.08 488.55 209.7 495.73 291.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "493.43 142.49 488.13 239.02 493.99 291.87 495.74 238.69 493.43 142.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "659.12 249.43 494.5 359.97 629.09 339.6 659.12 249.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "659.12 249.43 494.5 359.97 564.28 243.11 659.12 249.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "659.12 249.43 564.86 243.14 629.27 339.06 659.12 249.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "592.09 287.79 564.86 243.14 659.12 249.43 494.5 359.97 592.09 287.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "331.11 249.43 495.74 359.97 361.14 339.6 331.11 249.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "331.11 249.43 495.74 359.97 425.95 243.11 331.11 249.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "331.11 249.43 425.37 243.14 360.97 339.06 331.11 249.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "398.14 287.79 425.37 243.14 331.11 249.43 495.74 359.97 398.14 287.79"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M495.73,302.34c-127.08,0-230.08,100.15-230.08,223.68s103,223.71,230.08,223.71,230.08-100.17,230.08-223.71-103.02-223.68-230.08-223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M495.04,739.71c-125.35,0-227.27-97.47-230.02-218.7-.04,1.67-.06,3.34-.06,5.02,0,123.55,103.01,223.71,230.09,223.71s230.07-100.17,230.07-223.71c0-1.68-.03-3.35-.07-5.02-2.74,121.23-104.68,218.7-230,218.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M495.73,302.34c-127.08,0-230.08,100.15-230.08,223.68,0,2.73.12,5.4.23,8.11,58.6,51.1,139.29,82.7,228.36,82.7s172.58-32.73,231.42-85.42c.05-1.81.15-3.57.15-5.39,0-123.53-103.02-223.68-230.08-223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M679.34,390.65c-42.01-53.64-108.39-88.31-183.12-88.31s-142.13,35.19-184.11,89.53c52.01,31.23,114.9,49.52,182.62,49.52s132.21-18.76,184.6-50.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M495.73,315.14c124.84,0,226.4,96.74,229.9,217.29.07-2.12.18-4.25.18-6.4,0-123.53-103.02-223.68-230.08-223.68s-230.07,100.15-230.07,223.68c0,2.15.1,4.29.17,6.4,3.5-120.55,105.05-217.29,229.9-217.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M464.84,317.05c10.71-.82,21.75,3.25,16.39,7.91-5.36,4.65-41.57,25.54-57.36,12.63-15.82-12.93,28.37-19.58,40.96-20.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M340.35,373.93c-33.53,28.2-60.61,80.31-59.93,110.76.68,30.44,16.95-17.32,25.34-34.65,8.41-17.31,50.4-70.17,80.83-86.15,30.45-16.01,6.17-34.06-46.24,10.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M495.75,359.47c-94.49,0-171.08,74.48-171.08,166.33s76.59,166.33,171.08,166.33,171.05-74.47,171.05-166.33-76.57-166.33-171.05-166.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M495.47,703.22c-99.6,0-180.64-78.89-180.64-175.86s81.04-175.86,180.64-175.86,180.63,78.89,180.63,175.86-81.03,175.86-180.63,175.86ZM495.47,367.46c-90.8,0-164.69,71.73-164.69,159.9s73.89,159.9,164.69,159.9,164.67-71.73,164.67-159.9-73.87-159.9-164.67-159.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M495.75,359.47c-50.17,0-95.3,21-126.59,54.48,30.54-27.59,71.43-44.47,116.41-44.47,94.46,0,171.04,74.45,171.04,166.32,0,43.09-16.84,82.35-44.48,111.89,33.64-30.38,54.67-73.73,54.67-121.89,0-91.85-76.57-166.33-171.05-166.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.19,624.19c0-107.34,76.59-166.32,171.06-166.32,38.61,0,74.21,12.43,102.81,33.4-16.34-75.28-85.05-131.79-167.35-131.79-94.47,0-171.06,74.48-171.06,166.33,0,54.36,26.81,102.6,68.24,132.96-2.4-11.15-3.7-22.71-3.7-34.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M495.75,683.06c-92.83,0-168.33-71.92-170.92-161.56-.07,1.59-.15,3.17-.15,4.78,0,91.88,76.59,166.33,171.08,166.33s171.05-74.45,171.05-166.33c0-1.61-.07-3.19-.11-4.78-2.62,89.64-78.11,161.56-170.93,161.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M291.49,630.4s8.58,14.21,17.81,27.58l47.88-30.53-65.68,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M333.79,685.6l23.91-58.17-.53.02-47.88,30.53c.94,1.36,1.88,2.7,2.82,4.02,10.22,14.37,21.68,23.6,21.68,23.6Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "358.33 627.45 340.92 692.13 333.79 685.6 358.33 627.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "290.19 625.34 291.49 630.4 358.33 627.45 290.19 625.34"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M696.49,630.4s-8.58,14.21-17.81,27.58l-47.88-30.53,65.69,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M654.18,685.6l-23.9-58.17.52.02,47.88,30.53c-.93,1.36-1.87,2.7-2.81,4.02-10.22,14.37-21.68,23.6-21.68,23.6Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "629.65 627.45 647.06 692.13 654.18 685.6 629.65 627.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "697.8 625.34 696.49 630.4 629.65 627.45 697.8 625.34"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M436.27,295.42c-25.4,0-45.99,19.18-45.99,42.85s20.6,42.81,45.99,42.81,45.99-19.19,45.99-42.81-20.6-42.85-45.99-42.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M394.27,394.63c12.34-13.85,48.63-56.36,48.63-56.36,0,0,30.31-56.89,31.05-58.49.2-.46-38.74,53.49-38.74,53.49l-40.94,61.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M446.27,328.09c-11.18-8.75-9.15-33.34-9.24-40.3v6.67c0-1.06-.08-2.21-.08-2.46v-4.2c-.01,2-.15,5.16-.62,8.81,0,0-3.28,24.68-9.19,29.78-13.32,11.69-46.85,9.43-33.99,9.73,43.42.93,43.42,43.31,43.81,57.21v-7c.03.5.08.92.08,1.17v5.83c.92-32.91.81-53.73,38.69-56.51,12.55-.96-16.37,1.45-29.45-8.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "857.98 521.24 667.83 520.63 716.73 579.13 857.98 521.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "857.98 521.24 667.83 520.63 717.07 462.89 857.98 521.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "857.98 521.24 717.54 463.24 725.05 521.01 717.18 578.78 857.98 521.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "722.78 515.49 717.54 463.24 857.98 521.24 667.83 520.63 722.78 515.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "137.32 521.24 327.47 520.63 278.56 579.13 137.32 521.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "137.32 521.24 327.47 520.63 278.22 462.89 137.32 521.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "137.32 521.24 277.76 463.24 270.25 521.01 278.12 578.78 137.32 521.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "272.52 515.49 277.76 463.24 137.32 521.24 327.47 520.63 272.52 515.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "600.27 669.4 493.42 741.14 580.77 727.92 600.27 669.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "600.27 669.4 493.42 741.14 538.71 665.3 600.27 669.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "600.27 669.4 539.09 665.32 580.88 727.57 600.27 669.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "556.77 694.29 539.09 665.32 600.27 669.4 493.42 741.14 556.77 694.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "386.69 669.4 493.54 741.14 406.18 727.92 386.69 669.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "386.69 669.4 493.54 741.14 448.25 665.3 386.69 669.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "386.69 669.4 447.87 665.32 406.07 727.57 386.69 669.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "430.19 694.29 447.87 665.32 386.69 669.4 493.54 741.14 430.19 694.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "386.69 809.08 493.53 737.34 406.18 750.56 386.69 809.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "386.69 809.08 493.53 737.34 448.25 813.18 386.69 809.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "386.69 809.08 447.87 813.16 406.07 750.91 386.69 809.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "432.73 790.62 447.87 813.16 386.69 809.08 426.96 782.04 432.73 790.62"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "600.27 809.08 493.42 737.34 580.77 750.56 600.27 809.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "600.27 809.08 493.42 737.34 538.71 813.18 600.27 809.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "600.27 809.08 539.09 813.16 580.88 750.91 600.27 809.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "555.78 788.3 539.09 813.16 600.27 809.08 559.99 782.04 555.78 788.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "493.43 680.01 405.16 734.71 493.43 789.41 581.7 734.71 493.43 680.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "493.43 685.21 577.51 737.31 581.7 734.71 493.43 680.01 405.16 734.71 409.36 737.31 493.43 685.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "492.77 789.06 580.49 734.71 492.77 680.36 492.77 789.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "493.49 788.3 491.82 722.19 493.43 680.01 407.88 733.03 464.45 748.12 493.49 788.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "493.43 681.05 405.16 734.71 493.43 731.25 581.7 734.71 493.43 681.05"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M493.48,702.78c-17.66,0-31.97,13.92-31.97,31.08s14.32,31.09,31.97,31.09,31.97-13.92,31.97-31.09-14.31-31.08-31.97-31.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M493.43,767.02c-18.62,0-33.76-14.74-33.76-32.87s15.14-32.87,33.76-32.87,33.76,14.74,33.76,32.87-15.14,32.87-33.76,32.87ZM493.43,704.27c-16.97,0-30.78,13.4-30.78,29.88s13.81,29.88,30.78,29.88,30.78-13.4,30.78-29.88-13.81-29.88-30.78-29.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M493.48,702.78c-9.38,0-17.81,3.92-23.66,10.18,5.71-5.15,13.35-8.31,21.75-8.31,17.65,0,31.97,13.91,31.97,31.08,0,8.05-3.15,15.39-8.31,20.91,6.29-5.68,10.22-13.78,10.22-22.78,0-17.16-14.31-31.08-31.97-31.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.57,752.25c0-20.06,14.32-31.08,31.97-31.08,7.21,0,13.87,2.32,19.22,6.24-3.06-14.07-15.9-24.63-31.28-24.63-17.65,0-31.97,13.92-31.97,31.08,0,10.16,5.01,19.18,12.76,24.85-.45-2.08-.7-4.24-.7-6.46Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.c7f1a33110eeac32f59ffa69dfafa462.svg";
export { ForwardRef as ReactComponent };